export const NodeData = {
    id: "",
    name: "",
    description: "",
    createdon: new Date('1995-12-17T03:24:00'),
}